import {
    DEFAULT_CONTACT_ROLE,
    formatContactLine,
    getContactDisplayName,
    groupContactsByRole,
    type ContactDisplayItem
} from '../../common/components/contacts/contactDisplayUtils';

type RepresentativeDisplayContact = ContactDisplayItem;

type RepresentativeRoleGroup<T extends RepresentativeDisplayContact = RepresentativeDisplayContact> = {
    role: string;
    representatives: T[];
};

export const getRepresentativeName = getContactDisplayName;

export const formatRepresentativeLine = formatContactLine;

export const groupRepresentativesByRole = <T extends RepresentativeDisplayContact>(
    representatives: Array<T | null | undefined> = [],
    defaultRepresentativeRole: string = DEFAULT_CONTACT_ROLE
): RepresentativeRoleGroup<T>[] =>
    groupContactsByRole(representatives, defaultRepresentativeRole).map(({ role, contacts }) => ({
        role,
        representatives: contacts
    }));
